export default "__VITE_ASSET__CX4y8bws__"